import script from "./ContactFormBase.vue?vue&type=script&lang=ts"
export * from "./ContactFormBase.vue?vue&type=script&lang=ts"

const __exports__ = script;

export default __exports__